<div class="app-page-layout">
    <top-notification-bar data-html2canvas-ignore />

    <div class="app-page-content">
        <router-outlet />
    </div>
</div>
